import React from 'react';
import { DataVizContainer } from '../common/DataVizContainer';
import {
  OverTimeUnsegmentedVizConfig,
  OverTimeUnsegmentedVizExternalProps,
  OverTimeUnsegmentedVizViews,
} from './types';
import { useOverTimeConfigToData } from './useConfigToData';
import { overTimeViewConfigs } from './views/view-configs';

export interface OverTimeUnsegmentedVizProps {
  dataConfig: OverTimeUnsegmentedVizConfig;
  selectedView: OverTimeUnsegmentedVizViews;
  externalProps: OverTimeUnsegmentedVizExternalProps;
  persistenceKey: string;
}

export const OverTimeUnsegmentedViz = (props: OverTimeUnsegmentedVizProps) => {
  return (
    <DataVizContainer
      dataConfig={props.dataConfig}
      externalProps={props.externalProps}
      useConfigToData={useOverTimeConfigToData}
      selectedView={props.selectedView}
      viewConfigs={overTimeViewConfigs}
      persistenceKey={props.persistenceKey}
    />
  );
};
